export const onClickGsilLogo = () => {
  window.location.href = 'https://www.smartsitesafetysolution.com';
};

export const getDashboardMapLocation = (lat, lng, userId) => {
  const pathname = '/dashboard/chart';
  if (+lat && +lng && !Number.isNaN(+lat) && !Number.isNaN(+lng)) {
    let search = `?lat=${+lat}&lng=${+lng}&time=${new Date().getTime()}`;
    if (userId) search += `&userId=${userId}`;
    return { pathname, search };
  }
  return null;
};
